<ng-container *ngIf="order; else loadingOrder">
    <div class="justify-content-between d-none d-lg-flex">
        <a (click)="back()" class="fs-4 clickable"><i class="bi bi-arrow-left"></i></a>
    </div>
    <div class="actions d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 py-3">
        <div>
            <h3 class="m-0 p-0">{{ "Order ref" | translate: { ref: order.ref } }}</h3>
            <p class="p-0 m-0">{{ order.createdAt | date: "short" }}</p>
        </div>
        <div class="d-flex gap-3 flex-wrap justify-content-start justify-content-lg-end">
            <a class="btn btn-link text-nowrap" (click)="shipOrder()" *ngIf="shipOrderButtonVisible">
                <i class="bi bi-truck clickable me-2"></i>
                {{ "Ship order" | translate }}
            </a>
        </div>
    </div>
    <div class="alert alert-warning d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2" *ngIf="showProRevenuePendingInvoice">
        <span>{{ "Pro revenue pending invoice" | translate }}</span>
        <button type="button" class="btn btn-sm btn-outline-primary text-nowrap" (click)="createInvoice()">
            <i class="bi bi-upload me-1"></i>
            {{ "Upload invoice" | translate }}
        </button>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card p-3">
                <div class="row g-3 justify-content-center">
                    <div class="col-12 col-md-4">
                        <h5>{{ "Delivery Address" | translate }}</h5>
                        {{ order.deliveryAddress.mobilePhone }}<br />
                        {{ order.deliveryAddress.companyName }}<br />
                        {{ order.deliveryAddress.streetNumber }} {{ order.deliveryAddress.street }}<br />
                        {{ order.deliveryAddress.zip }} {{ order.deliveryAddress.city }}<br />
                        {{ order.deliveryAddress.region }} {{ order.deliveryAddress.country }}
                    </div>
                    <div class="col-12 col-md-4 offset-md-2">
                        <h5>{{ "Billing Address" | translate }}</h5>
                        {{ order.deliveryAddress.mobilePhone }}<br />
                        {{ order.deliveryAddress.companyName }}<br />
                        {{ order.billingAddress.streetNumber }} {{ order.billingAddress.street }}<br />
                        {{ order.billingAddress.zip }} {{ order.billingAddress.city }}<br />
                        {{ order.billingAddress.region }} {{ order.billingAddress.country }}
                    </div>
                </div>
            </div>
            <div class="py-3">
                <app-order-summary [order]="order" [showDetailButton]="false" [showTitle]="false"></app-order-summary>
            </div>
            <!-- Documents -->
            <div class="card p-3 mb-3">
                <h4>{{ "Documents" | translate }}</h4>
                <div class="list-group list-group-flush">
                    <!-- Contract -->
                    <div class="list-group-item d-flex justify-content-between align-items-center px-0">
                        <div>
                            <i class="bi bi-file-earmark-text me-2"></i>
                            {{ "Download contract" | translate }}
                        </div>
                        <button class="btn btn-sm btn-outline-primary" (click)="redirectToContract()">
                            <i class="bi bi-download me-1"></i>
                            {{ "Download" | translate }}
                        </button>
                    </div>
                    <!-- Invoice -->
                    <div class="list-group-item d-flex justify-content-between align-items-center px-0">
                        <div>
                            <i class="bi bi-receipt me-2"></i>
                            <span *ngIf="order?.invoice; else noInvoiceText">
                                {{ "Invoice -number-" | translate: { number: order?.invoice?.number } }}
                            </span>
                            <ng-template #noInvoiceText>
                                {{ "Invoice" | translate }}
                            </ng-template>
                        </div>
                        <div class="d-flex gap-2">
                            <button class="btn btn-sm btn-outline-primary" (click)="createInvoice()" *ngIf="isSeller && !order?.invoice">
                                <i class="bi bi-upload me-1"></i>
                                {{ "Upload" | translate }}
                            </button>
                            <button class="btn btn-sm btn-outline-primary" (click)="downloadInvoice()" *ngIf="order?.invoice">
                                <i class="bi bi-download me-1"></i>
                                {{ "Download" | translate }}
                            </button>
                            <span class="text-muted" *ngIf="!isSeller && !order?.invoice">
                                {{ "Pending" | translate }}
                            </span>
                        </div>
                    </div>
                    <!-- Delivery Slip -->
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center px-0"
                        *ngIf="isSeller && order.shipments.length > 0"
                    >
                        <div>
                            <i class="bi bi-file-text me-2"></i>
                            {{ "Delivery slip" | translate }}
                        </div>
                        <button class="btn btn-sm btn-outline-primary" (click)="downloadDeliverySlip()">
                            <i class="bi bi-download me-1"></i>
                            {{ "Download" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Transactions -->
        <div class="col-12">
            <!-- Shipments -->
            <div class="card p-3 mb-3">
                <h4>{{ "Shipments" | translate }}</h4>
                <table class="table" *ngIf="order.shipments.length > 0; else noShipments">
                    <thead>
                        <tr>
                            <th>{{ "Provider" | translate }}</th>
                            <th>{{ "Tracking Number" | translate }}</th>
                            <th>{{ "Shipment status" | translate }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let shipment of order.shipments">
                            <td>{{ shipment.provider.toUpperCase() }}</td>
                            <td>{{ shipment.code }}</td>
                            <td [class]="shipment.statusColor" class="fw-bold">{{ shipment.statusFormatted | translate }}</td>
                            <td>
                                <a [routerLink]="'/profile/orders/' + order.ref + '/shipments/' + shipment.code"
                                    ><i class="bi bi-truck"></i
                                ></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ng-template #noShipments>
                    <div class="text-center py-4">
                        <p>{{ "No shipments" | translate }}</p>
                        <a class="btn btn-outline-primary" [routerLink]="'/profile/orders/' + order.ref + '/shipments'" *ngIf="isSeller">
                            {{ "Create shipment sticker" | translate }}
                        </a>
                    </div>
                </ng-template>
            </div>
        </div>
        <!-- Transactions -->
        <div class="col-12">
            <div class="card p-3 mb-3">
                <h4>{{ "Transactions" | translate }}</h4>
                <table class="table" *ngIf="order.transactions.length > 0; else noTransactions">
                    <thead>
                        <tr>
                            <th>{{ "Date" | translate }}</th>
                            <th>{{ "Amount" | translate }}</th>
                            <th>{{ "Payment status" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let transaction of order.transactions">
                            <td>{{ transaction.createdAt | date: "short" }}</td>
                            <td><app-price [price]="transaction.amountPriceObject"></app-price></td>
                            <td [class]="transaction.statusColor" class="fw-bold">{{ transaction.statusFormatted | translate }}</td>
                        </tr>
                    </tbody>
                </table>
                <ng-template #noTransactions>
                    <div class="text-center py-4 text-warning">{{ "Pending payment" | translate }}</div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #loadingOrder>
    <div class="text-center py-4">
        <app-loader></app-loader>
    </div>
</ng-template>
